import { InformatDefaultPage } from "../../../04templates/informat/defaultPage/InformatDefaultPage";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { Icons } from "pu-crossproduct-components/build/components/Molecules/Navigation/IconButton";
import { Icon, Size } from "pu-crossproduct-components/build/components/Atoms/Icons/Icon";
import { H1, Body2 } from "pu-crossproduct-components/build/components/Atoms/Type/"
import { Button, Emphasis } from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import QueryString from "querystring"

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 72px;
`

const StyledActionButtonsSection = styled.div`
    display:flex;
    margin-bottom:72px;
    & > * { 
                margin: 8px; 
            };
`

export const InformatRrnrError: React.FC = props => {
    const { t } = useTranslation();

    const queryString = QueryString.parse(window.location.search.substring(1));
    const returnUrl = queryString["returnUrl"] as string ?? "";

    return (
        <InformatDefaultPage>
            <GridContainer>
                <GridRow>
                    <GridItem col={0} laptop={4} />
                    <GridItem col={12} laptop={4}>
                        <Content>
                            <Icon icon={Icons.error} size={Size.extraLarge} />
                            <H1><Trans t={t}>twoFactorInformatRrnrErrorTitle</Trans></H1>
                            <Body2><Trans t={t}>twoFactorInformatRrnrErrorDescription</Trans></Body2>
                            <StyledActionButtonsSection>
                                <Button
                                    emphasis={Emphasis.medium}
                                    onClick={() => window.open(`https://helpdesk.informat.be/hc/nl/articles/115001026364-Wachtwoord-vergeten-Account-geblokkeerd`)}>{t('twoFactorInformatRrnrErrorGetHelp')}</Button>
                                <Button onClick={() => window.location.href = `/informat/Retry?returnUrl=${encodeURIComponent(returnUrl)}`}>{t('twoFactorInformatRrnrErrorBackToLogin')}</Button>
                            </StyledActionButtonsSection>
                        </Content>
                    </GridItem>
                    <GridItem col={0} laptop={4} />
                </GridRow>
            </GridContainer>
        </InformatDefaultPage >
    )
}
